/**
 * Claims API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface ClaimCheckDto
 */
export interface ClaimCheckDto {
    /**
     * 
     * @type {string}
     * @memberof ClaimCheckDto
     */
    paymentType?: string;
    /**
     * 
     * @type {Date}
     * @memberof ClaimCheckDto
     */
    issueDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClaimCheckDto
     */
    clearDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimCheckDto
     */
    eisFlag?: boolean;
}
/**
 * 
 * @export
 * @interface ClaimDetailDto
 */
export interface ClaimDetailDto {
    /**
     * 
     * @type {string}
     * @memberof ClaimDetailDto
     */
    policyNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimDetailDto
     */
    maskedClaimNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimDetailDto
     */
    encrytpedClaimNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimDetailDto
     */
    claimantName?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimDetailDto
     */
    claimStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimDetailDto
     */
    primaryName?: string;
    /**
     * 
     * @type {Date}
     * @memberof ClaimDetailDto
     */
    claimReceiptDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClaimDetailDto
     */
    serviceFromDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClaimDetailDto
     */
    serviceThroughDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof ClaimDetailDto
     */
    totalPaidAmount: number;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimDetailDto
     */
    hasChecks: boolean;
    /**
     * 
     * @type {Array<Link>}
     * @memberof ClaimDetailDto
     */
    links?: Array<Link>;
    /**
     * 
     * @type {string}
     * @memberof ClaimDetailDto
     */
    coverageNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof ClaimDetailDto
     */
    processedDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClaimDetailDto
     */
    lastChangeDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof ClaimDetailDto
     */
    primaryInsuredPayment: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimDetailDto
     */
    providerPayment: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimDetailDto
     */
    reversalPayment: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimDetailDto
     */
    totalCharges: number;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimDetailDto
     */
    eisFlag?: boolean;
}
/**
 * 
 * @export
 * @interface ClaimDetailDtoAllOf
 */
export interface ClaimDetailDtoAllOf {
    /**
     * 
     * @type {string}
     * @memberof ClaimDetailDtoAllOf
     */
    coverageNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof ClaimDetailDtoAllOf
     */
    processedDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClaimDetailDtoAllOf
     */
    lastChangeDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof ClaimDetailDtoAllOf
     */
    primaryInsuredPayment: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimDetailDtoAllOf
     */
    providerPayment: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimDetailDtoAllOf
     */
    reversalPayment: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimDetailDtoAllOf
     */
    totalCharges: number;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimDetailDtoAllOf
     */
     eisFlag?: boolean;   
}
/**
 * 
 * @export
 * @interface ClaimDto
 */
export interface ClaimDto {
    /**
     * 
     * @type {string}
     * @memberof ClaimDto
     */
    policyNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimDto
     */
    maskedClaimNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimDto
     */
    encrytpedClaimNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimDto
     */
    claimantName?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimDto
     */
    claimStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimDto
     */
    primaryName?: string;
    /**
     * 
     * @type {Date}
     * @memberof ClaimDto
     */
    claimReceiptDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClaimDto
     */
    serviceFromDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClaimDto
     */
    serviceThroughDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof ClaimDto
     */
    totalPaidAmount: number;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimDto
     */
    hasChecks: boolean;
    /**
     * 
     * @type {Array<Link>}
     * @memberof ClaimDto
     */
    links?: Array<Link>;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimDto
     */
     eisFlag?: boolean; 
}
/**
 * 
 * @export
 * @interface Link
 */
export interface Link {
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    href?: string;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    rel?: string;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    verb?: string;
}

/**
 * ChecksApi - axios parameter creator
 * @export
 */
export const ChecksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {string} [policyNumber] 
         * @param {string} [encrytpedClaimNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checksGetClaimChecks(version: string, policyNumber?: string, encrytpedClaimNumber?: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling checksGetClaimChecks.');
            }
            const localVarPath = `/api/claims/v{version}/checks`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (policyNumber !== undefined) {
                localVarQueryParameter['policyNumber'] = policyNumber;
            }

            if (encrytpedClaimNumber !== undefined) {
                localVarQueryParameter['encrytpedClaimNumber'] = encrytpedClaimNumber;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChecksApi - functional programming interface
 * @export
 */
export const ChecksApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {string} [policyNumber] 
         * @param {string} [encrytpedClaimNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checksGetClaimChecks(version: string, policyNumber?: string, encrytpedClaimNumber?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClaimCheckDto>> {
            const localVarAxiosArgs = ChecksApiAxiosParamCreator(configuration).checksGetClaimChecks(version, policyNumber, encrytpedClaimNumber, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ChecksApi - factory interface
 * @export
 */
export const ChecksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {string} [policyNumber] 
         * @param {string} [encrytpedClaimNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checksGetClaimChecks(version: string, policyNumber?: string, encrytpedClaimNumber?: string, options?: any): AxiosPromise<Array<ClaimCheckDto>> {
            return ChecksApiFp(configuration).checksGetClaimChecks(version, policyNumber, encrytpedClaimNumber, options)(axios, basePath);
        },
    };
};

/**
 * ChecksApi - object-oriented interface
 * @export
 * @class ChecksApi
 * @extends {BaseAPI}
 */
export class ChecksApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {string} [policyNumber] 
     * @param {string} [encrytpedClaimNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChecksApi
     */
    public checksGetClaimChecks(version: string, policyNumber?: string, encrytpedClaimNumber?: string, options?: any) {
        return ChecksApiFp(this.configuration).checksGetClaimChecks(version, policyNumber, encrytpedClaimNumber, options)(this.axios, this.basePath);
    }

}


/**
 * ClaimsApi - axios parameter creator
 * @export
 */
export const ClaimsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} policyNumber 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimsGetByPolicyNumber(policyNumber: string, version: string, options: any = {}): RequestArgs {
            // verify required parameter 'policyNumber' is not null or undefined
            if (policyNumber === null || policyNumber === undefined) {
                throw new RequiredError('policyNumber','Required parameter policyNumber was null or undefined when calling claimsGetByPolicyNumber.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling claimsGetByPolicyNumber.');
            }
            const localVarPath = `/api/claims/v{version}/policies/{policyNumber}`
                .replace(`{${"policyNumber"}}`, encodeURIComponent(String(policyNumber)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClaimsApi - functional programming interface
 * @export
 */
export const ClaimsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} policyNumber 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimsGetByPolicyNumber(policyNumber: string, version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClaimDto>> {
            const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).claimsGetByPolicyNumber(policyNumber, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ClaimsApi - factory interface
 * @export
 */
export const ClaimsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} policyNumber 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimsGetByPolicyNumber(policyNumber: string, version: string, options?: any): AxiosPromise<Array<ClaimDto>> {
            return ClaimsApiFp(configuration).claimsGetByPolicyNumber(policyNumber, version, options)(axios, basePath);
        },
    };
};

/**
 * ClaimsApi - object-oriented interface
 * @export
 * @class ClaimsApi
 * @extends {BaseAPI}
 */
export class ClaimsApi extends BaseAPI {
    /**
     * 
     * @param {string} policyNumber 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApi
     */
    public claimsGetByPolicyNumber(policyNumber: string, version: string, options?: any) {
        return ClaimsApiFp(this.configuration).claimsGetByPolicyNumber(policyNumber, version, options)(this.axios, this.basePath);
    }

}


/**
 * DetailsApi - axios parameter creator
 * @export
 */
export const DetailsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} claimNumber 
         * @param {string} policyNumber 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detailsGetByPolicyNumber(claimNumber: string, policyNumber: string, version: string, options: any = {}): RequestArgs {
            // verify required parameter 'claimNumber' is not null or undefined
            if (claimNumber === null || claimNumber === undefined) {
                throw new RequiredError('claimNumber','Required parameter claimNumber was null or undefined when calling detailsGetByPolicyNumber.');
            }
            // verify required parameter 'policyNumber' is not null or undefined
            if (policyNumber === null || policyNumber === undefined) {
                throw new RequiredError('policyNumber','Required parameter policyNumber was null or undefined when calling detailsGetByPolicyNumber.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling detailsGetByPolicyNumber.');
            }
            const localVarPath = `/api/claims/v{version}/{claimNumber}/policies/{policynumber}/details`
                .replace(`{${"claimNumber"}}`, encodeURIComponent(String(claimNumber)))
                .replace(`{${"policyNumber"}}`, encodeURIComponent(String(policyNumber)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DetailsApi - functional programming interface
 * @export
 */
export const DetailsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} claimNumber 
         * @param {string} policyNumber 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detailsGetByPolicyNumber(claimNumber: string, policyNumber: string, version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimDetailDto> {
            const localVarAxiosArgs = DetailsApiAxiosParamCreator(configuration).detailsGetByPolicyNumber(claimNumber, policyNumber, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * DetailsApi - factory interface
 * @export
 */
export const DetailsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} claimNumber 
         * @param {string} policyNumber 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detailsGetByPolicyNumber(claimNumber: string, policyNumber: string, version: string, options?: any): AxiosPromise<ClaimDetailDto> {
            return DetailsApiFp(configuration).detailsGetByPolicyNumber(claimNumber, policyNumber, version, options)(axios, basePath);
        },
    };
};

/**
 * DetailsApi - object-oriented interface
 * @export
 * @class DetailsApi
 * @extends {BaseAPI}
 */
export class DetailsApi extends BaseAPI {
    /**
     * 
     * @param {string} claimNumber 
     * @param {string} policyNumber 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DetailsApi
     */
    public detailsGetByPolicyNumber(claimNumber: string, policyNumber: string, version: string, options?: any) {
        return DetailsApiFp(this.configuration).detailsGetByPolicyNumber(claimNumber, policyNumber, version, options)(this.axios, this.basePath);
    }

}


/**
 * HeartbeatApi - axios parameter creator
 * @export
 */
export const HeartbeatApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        heartbeatGet(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling heartbeatGet.');
            }
            const localVarPath = `/api/claims/v{version}/heartbeat`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HeartbeatApi - functional programming interface
 * @export
 */
export const HeartbeatApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        heartbeatGet(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = HeartbeatApiAxiosParamCreator(configuration).heartbeatGet(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * HeartbeatApi - factory interface
 * @export
 */
export const HeartbeatApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        heartbeatGet(version: string, options?: any): AxiosPromise<void> {
            return HeartbeatApiFp(configuration).heartbeatGet(version, options)(axios, basePath);
        },
    };
};

/**
 * HeartbeatApi - object-oriented interface
 * @export
 * @class HeartbeatApi
 * @extends {BaseAPI}
 */
export class HeartbeatApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HeartbeatApi
     */
    public heartbeatGet(version: string, options?: any) {
        return HeartbeatApiFp(this.configuration).heartbeatGet(version, options)(this.axios, this.basePath);
    }

}


